import { render, staticRenderFns } from "./boletim24.vue?vue&type=template&id=282e5bd9&"
import script from "./boletim24.vue?vue&type=script&lang=js&"
export * from "./boletim24.vue?vue&type=script&lang=js&"
import style0 from "./boletim24.vue?vue&type=style&index=0&id=282e5bd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports